import { Button, Input } from '@chakra-ui/react'
import { AxiosError } from 'axios'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { FormField } from '../../../components/FormField'
import { Icon } from '../../../components/Icon'
import { MaskedInput } from '../../../components/MaskedInput'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'
import { FormSelect } from '../../../components/Select'
import { useAppToast } from '../../../helpers'
import { IRefundStorePayload } from '../../../services/Refunds/interfaces'
import RefundsService from '../../../services/Refunds/RefundsService'
import { ISector, SectorService } from '../../../services/Sector/SectorService'

export default function RefundsNewPage() {
  const navigate = useNavigate()
  const toast = useAppToast()
  const refundsService = useMemo(() => new RefundsService(), [])
  const [formAnswers, setFormAnswers] = useState<IRefundStorePayload>({
    name: '',
    email: '',
    phone: '',
    sector_id: 0
  })
  const sectorService = useMemo(() => new SectorService(), [])
  const [sectors, setSectors] = useState<ISector[]>([])
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({})

  useEffect(() => {
    const fetchSectors = async () => {
      try {
        const response = await sectorService.listForSelect()
        setSectors(response)
      } catch {
        toast.error('Erro ao buscar a lista de Setores!')
      }
    }

    fetchSectors()
  }, [])

  const handleSubmit = async () => {
    setErrors({})
    try {
      const response = await refundsService.store(formAnswers)
      navigate(`/refunds/${response.data.refund.id}`)
    } catch (error: unknown) {
      const axiosError = error as AxiosError<{ errors: Record<string, string[]> }>
      toast.error('Erro ao criar a Solicitação de Reembolso!', error)
      if (axiosError.response?.data?.errors) {
        setErrors(axiosError.response.data.errors)
      }
    }
  }

  return (
    <PublicFormLayout title="Solicitação de Reembolso">
      <form>
        <FormField label="Nome do Solicitante" isRequired={true} mb="4" error={errors['name']}>
          <Input
            value={formAnswers['name']}
            onChange={(event) => setFormAnswers({ ...formAnswers, name: event.target.value })}
          />
        </FormField>

        <FormField label="E-mail do Solicitante" isRequired={true} mb="4" error={errors['email']}>
          <Input
            value={formAnswers['email']}
            onChange={(event) => setFormAnswers({ ...formAnswers, email: event.target.value })}
          />
        </FormField>

        <FormField label="Telefone do Solicitante" isRequired={true} mb="4" error={errors['phone']}>
          <MaskedInput
            mask="phone"
            value={formAnswers['phone']}
            onChange={(phone) => setFormAnswers({ ...formAnswers, phone })}
          />
        </FormField>

        <FormField label="Setor" isRequired={true} mb="4" error={errors['sector_id']}>
          <FormSelect
            value={formAnswers['sector_id']}
            onChange={(value) => setFormAnswers({ ...formAnswers, sector_id: Number(value) })}
            options={sectors.map((sector) => ({ value: sector.id, label: sector.name }))}
            placeholder="Selecione uma opção"
          />
        </FormField>

        <Button colorScheme="magenta" onClick={handleSubmit}>
          Solicitar Reembolso &nbsp;
          <Icon name="lni lni-checkmark" />
        </Button>
      </form>
    </PublicFormLayout>
  )
}
